import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { Client } from 'api';
import Tracker from 'tracker';
import AlertActions from 'actions/alertActions';
import LeadActions from 'actions/leadActions';
import { SelectField, TextField } from 'components/forms';

const REASONS = [
    'Out of budget',
    'Date unavailable',
    'Capacity constraints',
    'Type of event not a fit',
    'User not a fit',
    'Other',
];

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReasonChanged = this.handleReasonChanged.bind(this);
        this.handleOtherReasonChanged = this.handleOtherReasonChanged.bind(this);

        this.api = new Client();
        this.tracker = new Tracker();

        this.state = {
            modalOpen: false,
            saving: false,
            reason: REASONS[0],
        };
    }

    componentWillUnmount() {
        this.api.clear();
    }

    toggleModal() {
        this.setState({ modalOpen: !this.state.modalOpen });
    }

    handleReasonChanged(option) {
        this.setState({ reason: option.value });
    }

    handleOtherReasonChanged(value) {
        this.setState({ otherReason: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        const reason = this.state.reason === 'Other' ? this.state.otherReason : this.state.reason;

        this.setState({ saving: true });
        this.api.request(`/api/leads/${this.props.leadId}/reject`, {
            method: 'POST',
            data: {
                reason: reason,
            },
            success: (data) => {
                if (data.error) {
                    this.setState({ saving: false, error: data.error });
                    return;
                }

                this.toggleModal();
                AlertActions.addAlert({
                    message: 'Thank you for your feedback. This lead has been removed from your dashboard.',
                    type: 'success',
                });

                LeadActions.saveLead(data);
            },
            error: () => {
                this.setState({ saving: false });
            },
        });
    }

    render() {
        return (
            <button className="btn btn-primary-light reject-lead" onClick={this.toggleModal}>
                No

                <Modal show={this.state.modalOpen} onHide={this.toggleModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Reject Lead
                        </Modal.Title>
                    </Modal.Header>

                    <div className="modal-body">
                        <p>Letting us know why you you're not interested in this lead will help us customize the leads we send you.</p>

                        <p>Your response to this question will not be shared with the user.</p>

                        <SelectField
                            label="Reason"
                            width="style"
                            value={this.state.reason}
                            onChange={this.handleReasonChanged}
                            options={REASONS.map(reason => {
                                return { label: reason, value: reason };
                            })}
                        />

                        {this.state.reason === 'Other' && <TextField
                            name="other_reason"
                            label="Please specify (optional)"
                            value={this.state.otherReason}
                            onChange={this.handleOtherReasonChanged}
                        />}
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-dark" onClick={this.handleSubmit} disabled={this.state.saving}>
                            Decline Lead
                        </button>
                    </div>
                </Modal>
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/rejectLead.jsx